import api from "../http/api";

export const getIndicatorBaseline = async (institutionId) => {
  try {
    const response = await api.client.get("api/v1/IndicatorBaseline", {
      headers: { institutionId }
    });
    return response.data?.indicatorBaseline || null;
  } catch (error) {
    console.error("Erro ao buscar o semáforo de indicadores:", error);
    throw new Error("Falha ao carregar os indicadores");
  }
};
